// extracted by mini-css-extract-plugin
export var downArrow = "_aa-0";
export var infoTooltipIcon = "_aa-3";
export var label = "_aa-1";
export var optionCard = "_aa-4";
export var upArrow = "_aa-2";